var option_webview_default = {
  "option": "jdTnM",
  "user_choice": "_0-Qj-",
  "check": "jnMlY",
  "image": "cDUMc",
  "input": "j2iv6",
  "title": "e70Fc",
  "centered": "BCnEN",
  "with_result": "_2bLXk",
  "list": "yvQ1R",
  "with_image": "k2N34",
  "progress": "wCM68",
  "progress_value": "_3D7I1",
  "label": "bCuXL",
  "cta": "creRA",
  "adornment_icon": "sA-Up",
  "remove": "Zxd5F",
  "removeButton": "-uzMf",
  "removeButtonIcon": "qo3sP",
  "overlay": "Ht5Ug",
  "shown": "USDcW",
  "dark": "BHtKC",
  "spinner": "Ynl1F",
  "spin": "jveUd",
  "grid": "mKRfN"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
